(function () {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', function () {
      navigator.serviceWorker.register(
        '//www.desithreads.in/cdn/shop/t/6/assets/pwa-sw.js?v=22559404688013509071780382414',
        { scope: '/' }
      ).catch(function () {});
    });
  }

  function track(eventName) {
    if (typeof gtag === 'function') {
      gtag('event', eventName, { event_category: 'PWA' });
    }
  }

  window.addEventListener('beforeinstallprompt', function (e) {
    track('pwa_install_prompt_shown');
    e.userChoice.then(function (choice) {
      track(choice.outcome === 'accepted' ? 'pwa_install_accepted' : 'pwa_install_dismissed');
    });
  });

  window.addEventListener('appinstalled', function () {
    track('pwa_installed');
  });

  // Fires on every visit opened from the home screen icon (iOS + Android)
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
    track('pwa_launch');
  }
})();
